<template>
  <div>
    <transition mode="out-in" name="page">
      <component
        ref="step"
        v-bind:is="currentStep"
        @next="next"
        @back="back"
        @cancel="cancel"
      />
    </transition>

    <SmartModal
      v-if="modalValidateDateError"
      v-bind="modalValidateDateError"
      @close="
        modalValidateDateError = null;
        retroativeDate = null;
      "
    >
      {{ modalValidateDateError.text }}
    </SmartModal>

    <SmartModal
      v-if="modal && !storeTerm.posVenda.isBaseLoyalty"
      v-bind="modal"
      @close="modal = null"
      :iconSize="15"
      containerClass="modal-container-bigger mt-10"
    >
      {{ modal.text }}
      <SmartContainer>
        <SmartRow
          class="
            form
            flex
            sub-form
            justify-between
            flex-nowrap flex-row
            p-3
            margin-top:
            5%;
          "
        >
          <div class="w-full">
            <SmartButton
              class="mx-1 modal-button"
              id="btnNo"
              quaternary
              @click="skipDependent"
              >Não, Pular</SmartButton
            >
          </div>
          <div class="w-full">
            <SmartButton
              class="mx-1 modal-button"
              id="btnYes"
              @click="addDependent"
              >Sim, Adicionar Dependentes</SmartButton
            >
          </div>
        </SmartRow>
      </SmartContainer>
    </SmartModal>

    <SmartModal
      v-if="modalResume"
      v-bind="modalResume"
      @close="modalResume = null"
      :iconSize="15"
      containerClass="modal-container-bigger"
    >
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-3"
      >
        <div class="w-full">{{ modalResume.text }}</div>
      </SmartRow>
      <SmartContainer>
        <SmartRow
          v-if="retroativeDate"
          class="form form-group flex sub-form flex-nowrap flex-row p-3 mt-4"
          style="justify-content: center"
        >
          <div>
            <SmartInput
              label="Local"
              placeholder="Local"
              :readonly="true"
              :value="paymentLocal"
              class="form-control"
            />
          </div>
          <div>
            <SmartInput
              label="Dia"
              id="retroativeDay"
              name="retroativeDay"
              placeholder="Dia"
              v-model="day"
              :error="errors.first('retroativeDay')"
              style="max-width: 60px"
            />
          </div>
          <div>
            <SmartInput
              label="Mês"
              id="retroativeMonth"
              placeholder="Informe o Mês"
              name="informe o mês"
              v-model="month"
              :error="errors.first('retroativeMonth')"
              style="max-width: 90px"
            />
          </div>
          <div>
            <SmartInput
              label="Ano"
              id="retroativeYear"
              placeholder="Informe o ano"
              name="retroativeYear"
              v-model="year"
              :error="errors.first('retroativeYear')"
              style="max-width: 80px"
            />
          </div>
        </SmartRow>
        <SmartRow
          class="
            form
            flex
            sub-form
            justify-between
            flex-nowrap flex-row
            p-3
            mt-4
          "
        >
          <div class="w-full">
            <SmartButton
              class="mx-1 modal-button"
              id="btnNo"
              quaternary
              @click="noModalResume"
              >Não</SmartButton
            >
          </div>
          <div class="w-full">
            <SmartButton
              class="mx-1 modal-button"
              id="btnYes"
              @click="showRetroativeDate()"
              >Sim</SmartButton
            >
          </div>
        </SmartRow>
      </SmartContainer>
    </SmartModal>
  </div>
</template>
<script>
import term from "store/term.store";
import fineTable from "store/fineTable.store";
import address from "store/address.store";
import { mapActions, mapGetters } from "vuex";
import * as stepsConfig from "./stepsconfig.js";

const TERM_STORE = "term";
const ADDRESS_STORE = "address";
const FINE_TABLE_STORE = "fineTable";
export default {
  name: "termTitular",
  data() {
    return {
      modal: null,
      modalResume: null,
      modalValidateDateError: null,
      currentStep: "StartConfig",
      steps: ["StartConfig"],
      year: null,
      month: null,
      day: null,
      retroativeDate: null,
      paymentLocal: ""
    };
  },
  components: {
    ...stepsConfig.components,
    Header: () => import("views/Header.vue"),
  },
  computed: {
    ...mapGetters({
      storeTerm: "term/term",
    }),
    indexCurrentStep() {
      return this.steps.indexOf(this.currentStep);
    },
  },
  methods: {
    ...mapActions({
      resetDependent: "term/resetDependent",
      resetTerm: "term/resetTerm",
      setTerm: "term/setTerm",
      setPayment: "term/setPayment",
    }),
    cancel() {
      this.resetTerm();
      this.currentStep = "StartConfig";
    },
    validaData(e) {
      e.preventDefault();
    },
    showRetroativeDate() {
      this.retroativeDate =
        this.retroativeDate === null || this.retroativeDate === undefined
          ? (this.retroativeDate = true)
          : this.yesModalResume();
          this.paymentLocal = window.localStorage.getItem("paymentLocal");
    },
    noModalResume() {
      this.retroativeDate = null;

      const term = JSON.parse(JSON.stringify(this.storeTerm));
      const d = new Date();
      term.payment.day = ` ${d.getDate()}`;
      term.payment.month = ` ${d.toLocaleString("pt-BR", { month: "long" })}`;
      term.payment.year = ` ${d.getFullYear()}`;
      term.changeDate = false;
      term.day = term.payment.day;
      term.month = term.payment.month;
      term.year = term.payment.year;
      this.setTerm(term);
      this.setPayment(term.payment);
      this.next(true);
    },
    yesModalResume() {
      if (this.validateRetroativeDate()) {
        const term = JSON.parse(JSON.stringify(this.storeTerm));
        term.changeDate = false;
        term.day = this.day;
        term.month = this.month;
        term.year = this.year;
        this.setTerm(term);
        this.next(true);
        this.retroativeDate = null;
      }
    },
    skipDependent() {
      this.resetDependent();
      const indexDependent = this.steps.indexOf("Dependent");
      if (indexDependent !== -1) {
        this.steps.splice(indexDependent, 1);
      }
      this.next(true);
    },
    addDependent() {
      if (this.steps.indexOf("Dependent") === -1) {
        this.steps.splice(this.indexCurrentStep + 1, 0, "Dependent");
      }
      this.next(true);
    },
    async next(isModal) {
      const isValid = await this.$refs.step.isValid();
      if (!isValid && !isModal) {
        return;
      }
      this.steps = stepsConfig.getSteps(this.storeTerm);
      if (
        stepsConfig.isModal(this.currentStep, this.storeTerm) &&
        this.modal === null
      ) {
        this.modal = {
          type: "warning",
          title: "Adicionar dependentes",
          icon: "dependent",
          text: "Você deseja adicionar dependentes ao seu pacote familia?",
        };
        return;
      }
      if (
        stepsConfig.isModalResume(this.currentStep, this.storeTerm) &&
        this.modalResume === null
      ) {
        if (this.retroativeDate === null) {
          const date = new Date();
          this.year = date.getFullYear();
          this.month = date.toLocaleString("pt-BR", { month: "long" });
          this.day = date.getDate();
        }
        this.modalResume = {
          type: "warning",
          title: "Atenção",
          icon: "alert",
          text: "Necessário alterar data para correção de anomalia?",
        };
        return;
      }

      if (this.indexCurrentStep < this.steps.length - 1) {
        this.currentStep = this.steps[this.indexCurrentStep + 1];
      }
      this.modal = null;
      this.modalResume = null;
    },
    validateRetroativeDate() {
      let dia = this.day;
      let mes = "x";
      switch (this.month.toUpperCase().trim()) {
        case "JANEIRO":
          mes = 0;
          break;
        case "FEVEREIRO":
          mes = "1";
          break;
        case "MARÇO":
          mes = "2";
          break;
        case "ABRIL":
          mes = "3";
          break;
        case "MAIO":
          mes = "4";
          break;
        case "JUNHO":
          mes = "5";
          break;
        case "JULHO":
          mes = "6";
          break;
        case "AGOSTO":
          mes = "7";
          break;
        case "SETEMBRO":
          mes = "8";
          break;
        case "OUTUBRO":
          mes = "9";
          break;
        case "NOVEMBRO":
          mes = "10";
          break;
        case "DEZEMBRO":
          mes = "11";
          break;
        default:
          mes = "x";
      }
      let ano = this.year;
      let data = new Date(ano, mes, dia);
      var msgTitle = "";
      var msg = "";
      if (
        isNaN(data.getDate()) ||
        data.getDate() !== parseInt(dia) ||
        data.getMonth() !== parseInt(mes) ||
        data.getFullYear() !== parseInt(ano)
      ) {
        msgTitle = "Data inválida";
        msg = "A data informada não é válida";
      } else {
        var dataAtual = new Date();
        var dataFutura = new Date(
          dataAtual.getFullYear(),
          dataAtual.getMonth(),
          dataAtual.getDate()
        );
        var ultimaData = new Date(
          dataAtual.getFullYear(),
          dataAtual.getMonth() - 1,
          1
        );
        if (data < ultimaData) {
          msgTitle = "Data retroativa";
          msg = "O limite máximo para data retroativa é de 1 mês";
        } else if (data > dataFutura) {
          msgTitle = "Data futura";
          msg = "Não é permitida data futura";
        }
      }

      if (msg !== "") {
        this.modalResume = null;

        this.modalValidateDateError = {
          type: "warning",
          title: msgTitle,
          icon: "warning",
          buttonText: "Corrija para continuar!",
          text: msg,
        };
        this.errors.add({
          field: null,
          msg: msg,
        });

        return false;
      }
      return true;
    },
    goto(step) {
      this.currentStep = step;
    },
    back() {
      if (this.indexCurrentStep !== 0) {
        this.currentStep = this.steps[this.indexCurrentStep - 1];
      } else {
        this.$emit("back");
      }
    },
    async print() {
      const isValid = await this.$refs.step.isValid();
      if (!isValid && !isModal) {
        return;
      }

      window.print();
    },
  },
  beforeCreate() {
    this.$store.registerModule(TERM_STORE, term);
    this.$store.registerModule(ADDRESS_STORE, address);
    this.$store.registerModule(FINE_TABLE_STORE, fineTable);
  },
  beforeDestroy() {
    this.$store.unregisterModule(TERM_STORE);
    this.$store.unregisterModule(ADDRESS_STORE);
    this.$store.unregisterModule(FINE_TABLE_STORE);
  },
};
</script>

<style lang="scss" scoped>
.navigator {
  display: flex;
  justify-content: flex-end;
}
.modal-button {
  width: 90%;
}
</style>
